import PostsService from '../../services/PostsService'

// Timer do polling do job de atualização (fora do state: não precisa ser reativo).
let updatePollTimer = null;

const state = () => ({
    post: null,
    posts: localStorage.getItem('posts') ? JSON.parse(localStorage.getItem('posts')) : [],
    postsLoading: false,
    loadingUpdatePosts: false,
    updateJob: null
})
  
const mutations = {
    SET_POST: (state, payload) => {
        state.post = payload;
    },
    SET_POSTS: (state, payload) => {
        if(payload.pageNumber == 1) {
            state.posts = payload.posts
        }else{
            state.posts = [...state.posts, ...payload.posts]
        }
        state.page =  payload.pageNumber
        state.pages =  payload.pages
        state.total =  payload.total
    },
    SET_POSTS_LOADING: (state, payload) => {
        state.postsLoading = payload;
    },
    SET_POSTS_LOADING_UPDATE: (state, payload) => {
        state.loadingUpdatePosts = payload;
    },
    SET_UPDATE_JOB: (state, payload) => {
        state.updateJob = payload;
    }
}

const actions = {
    async fetchPosts({commit}, { keyword = '', pageNumber = 1, sortBy = 'recentes', category = ''}){
        try {
            commit('SET_POSTS_LOADING', true);
            const response = await PostsService.get(keyword, pageNumber, sortBy, category);
            commit('SET_POSTS', response.data);
            commit('SET_POSTS_LOADING', false);
        } catch (error) {
            commit('SET_POSTS_LOADING', false);
            commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    async fetchPost({commit}, slug){
        try {
            commit('SET_POSTS_LOADING', true);
            const response = await PostsService.getOne(slug);
            commit('SET_POST', response.data);
            commit('SET_POSTS_LOADING', false);
        } catch (error) {
            commit('SET_POSTS_LOADING', false);
            // commit('LOG_USER_OUT');
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response.data.message
            });
        }
    },
    // Dispara a atualização dos posts (job em segundo plano no backend) e passa
    // a acompanhar o progresso por polling — assim a requisição não estoura o
    // tempo limite mesmo com centenas de posts.
    async updatePosts({commit, dispatch, state}, payload = {}){
        try {
            if(state.loadingUpdatePosts) return
            commit('SET_POSTS_LOADING_UPDATE', true);

            const response = await PostsService.updateAll(payload.resume === true); // 202 Accepted
            commit('SET_UPDATE_JOB', response.data.job || null);
            commit('SET_ALERT', {
                heading: 'success',
                message: response.data.message
            });

            dispatch('pollUpdatePosts');
        } catch (error) {
            // 409 = já existe um job rodando: apenas acompanhamos o existente.
            if (error.response && error.response.status === 409) {
                commit('SET_ALERT', {
                    heading: 'info',
                    message: error.response.data.message
                });
                dispatch('pollUpdatePosts');
                return;
            }
            commit('SET_POSTS_LOADING_UPDATE', false);
            commit('SET_ALERT', {
                heading: 'error',
                message: error.response ? error.response.data.message : 'Erro ao iniciar a atualização.'
            });
        }
    },

    // Faz polling do status do job até concluir (ou falhar).
    pollUpdatePosts({commit, dispatch}){
        if (updatePollTimer) clearInterval(updatePollTimer);
        commit('SET_POSTS_LOADING_UPDATE', true);

        updatePollTimer = setInterval(async () => {
            try {
                const { data: job } = await PostsService.updateAllStatus();
                commit('SET_UPDATE_JOB', job);

                if (job.status === 'done') {
                    clearInterval(updatePollTimer);
                    updatePollTimer = null;
                    commit('SET_POSTS_LOADING_UPDATE', false);
                    commit('SET_ALERT', {
                        heading: 'success',
                        message: job.message || 'Posts atualizados com sucesso.'
                    });
                    await dispatch('fetchPosts', { keyword: "" });
                } else if (job.status === 'interrupted' || job.status === 'error') {
                    clearInterval(updatePollTimer);
                    updatePollTimer = null;
                    commit('SET_POSTS_LOADING_UPDATE', false);
                    // Importação interrompida por erro transitório: nada foi perdido,
                    // dá para retomar de onde parou (botão "Retomar" no admin).
                    commit('SET_ALERT', {
                        heading: 'alert',
                        message: job.message || job.error || 'Importação interrompida. É possível retomar.'
                    });
                    // Atualiza a lista com o que já foi importado até aqui.
                    await dispatch('fetchPosts', { keyword: "" });
                }
            } catch (error) {
                clearInterval(updatePollTimer);
                updatePollTimer = null;
                commit('SET_POSTS_LOADING_UPDATE', false);
            }
        }, 4000);
    },

    // Ao montar a tela: se já houver um job em andamento, retoma o acompanhamento.
    async resumeUpdatePosts({commit, dispatch}){
        try {
            const { data: job } = await PostsService.updateAllStatus();
            commit('SET_UPDATE_JOB', job);
            if (job.status === 'running') {
                dispatch('pollUpdatePosts');
            }
        } catch (error) {
            // silencioso: nenhum job para retomar
        }
    },
}

const getters = {
    getPost: state => state.post,
    getPosts: state => state.posts,
    getPostsLoading: state => state.postsLoading,
    getLoadingUpdatePosts: state => state.loadingUpdatePosts,
    getUpdateJob: state => state.updateJob,
}

export default {
    state,
    getters,
    mutations,
    actions
};